"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.negativeInventorySaleMessage = void 0;
const buildMessageFromQuantityRemaining = (quantityRemaining, { lotTracked = false } = {}) => {
    if (quantityRemaining < 1) {
        return 'Out of stock';
    }
    const itemText = quantityRemaining > 1 ? 'items' : 'item';
    const trackType = lotTracked ? 'lot' : 'stock';
    return `Only ${quantityRemaining} ${itemText} in ${trackType}`;
};
const batchTrackedNotAssignedMessage = (batches) => {
    const totalBatchQuantity = batches.reduce((total, batch) => total + batch.quantityRemaining, 0);
    return buildMessageFromQuantityRemaining(totalBatchQuantity, {
        lotTracked: true,
    });
};
const batchTrackedMessage = (batches, batchId) => {
    const productBatch = batches.find((batch) => batch.id === batchId);
    if (!productBatch) {
        return batchTrackedNotAssignedMessage(batches);
    }
    return buildMessageFromQuantityRemaining(productBatch.quantityRemaining, {
        lotTracked: true,
    });
};
const negativeInventorySaleMessage = (posListing, batchId) => {
    if (posListing.isBatchTracked) {
        return batchId
            ? batchTrackedMessage(posListing.batches, batchId)
            : batchTrackedNotAssignedMessage(posListing.batches);
    }
    return buildMessageFromQuantityRemaining(posListing.quantity);
};
exports.negativeInventorySaleMessage = negativeInventorySaleMessage;
//# sourceMappingURL=negativeInventorySaleMessage.js.map